import {styled} from "styled-components";
import {Button, Card, Tag} from "antd";

export const StyledButton = styled(Button)`
    font-size: .7rem !important;
    border-radius: 10px;
`;
